import React, { useCallback, useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useTranslator } from '@jutro/locale';
import { Grid } from '@jutro/layout';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import moment from 'moment';
import { FormattedDate } from 'react-intl';
import metadata from './ConfirmationPage.metadata.json5';
import messages from '../../FNOL.messages';
import styles from './ConfirmationPage.module.scss';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function ConfirmationPage(props) {
    const {
        history: { location: { state } },

        match: {
            params: { claimNumber }
        },
        
    } = props;
    

    const claimData = props?.history?.location?.state?.data;
    const anicCoreStates = props?.history?.location?.state?.data?.anicCoreStates;
    const claimState=props?.history?.location?.state?.data?.lossLocation?.state;
    const uWingOrg = props?.history?.location?.state?.data?.policy?.uwingOrganization
    const translator = useTranslator();
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [tbd,setTbd]=useState('');
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const allStatesObject = [
        {
            "State": "Alabama",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Arkansas",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Connecticut",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Delaware",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "District of Columbia",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Florida",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Georgia",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Hawaii",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Illinois",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Indiana",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Iowa",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Kansas",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Kentucky",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Maine",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Maryland",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Massachusetts",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Michigan",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Minnesota",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Mississippi",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Missouri",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Montana",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Nebraska",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "New Hampshire",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "New Jersey",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "North Carolina",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Oklahoma",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Oregon",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Pennsylvania",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Rhode Island ",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "South Carolina",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "South Dakota",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Tennessee",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Texas",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "ANIC",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Vermont",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Virginia",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "West Virginia",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        },
        {
            "State": "Wisconsin",
            "Underwring Company": "ANIC",
            "Underwriting Paper": "Old Republic",
            "Claims Administrator": "Corvel"
        }
    ]

    useEffect(() => {
        const ClaimFilter = _.filter(anicCoreStates, (jurisdictionStateItem) => {
            return claimState === jurisdictionStateItem;
        });


        if (ClaimFilter.length === 0 || (uWingOrg && uWingOrg === 'cp_anic_fairfield_ins_ext' || uWingOrg === 'cp_anic_oldrepublic_ins_ext' || uWingOrg === 'cp_anic_argonaut_ins_ext')) {
            setTbd("TBD")
        }
        
    },[anicCoreStates, claimState]) 

    useEffect(() => {
        trackPageView("Confirmation","/confirmation/claimnum")
    },[])

    useEffect(() => {
        trackGAPageView("/confirmation/claimnum","FNOL Confirmation")
    },[])
   

    const handlePrint = useCallback((e) => {
        e.preventDefault();
        window.print();
    }, []);

    const handleClick = useCallback(() => {
        const { history } = props;
        
        const redirectpath = {
            pathname: '/claims',
           
        };
        history.push(redirectpath);
    },[props]);

   

    const getClaimText=useCallback(()=>{
        return (
            <>
                <div className={styles.staticText}>
                    {translator(messages.claimStaticText)}<br/>
                    {translator(messages.claimStaticText1)} <br/>
                    {translator(messages.claimStaticText2)} <br/>
                    {translator(messages.claimStaticText3)} <br/>
                    {translator(messages.claimStaticText4)} <br/>
                    {translator(messages.claimStaticText5)} <br/>
                </div><br/>
                <div className={styles.mailText}>
                    {translator(messages.mailingAddress)} 
                </div><br/>
                <div>
                    <Grid
                        columns={['25%', '50%']}
                        alignContent="top"
                    >
                        <div>
                            CopperPoint Insurance Companies<br/>
                            PO Box 3477<br/>
                            Portland, OR 97208-3477
                        </div>
                    </Grid>
                </div><br/><br/>
                <div className={styles.compensationText}>
                    {translator(messages.compensationText)} 
                </div>
                <Grid
                    columns={['25%', '50%']}
                    alignContent="top"
                >
                    <div>{translator(messages.faxText)} </div>
                    <div>
                        CopperPoint Insurance Companies<br/>
                        Fax: (888) 362-0687<br/>
                        Email: Corvel_Copperpoint@onlinecapturecenter.com 
                    </div>
                </Grid>         
            </>
        );
    },[translator])

    const getFormattedDate = ((value) => {
        //const periodValue=moment.utc(value.toLocaleString());
        return moment(value).format('MM/DD/YYYY');
    
    })

    const getAdjusterName = (claimDetailsData, trans) => {
        if (claimDetailsData.adjuster.displayName) {
            const email = !_.isEmpty(claimDetailsData.adjuster.email)?claimDetailsData.adjuster.email:""
            return <a style={{'text-decoration':'none', 'color':'#26a9e0'}} className="adjusterEmail" href={`mailto:${email}`}>{claimDetailsData.adjuster.displayName}</a>;
        }
        return trans(messages.unknown);
    };


    const overrides = {
        claimReferenceNumber: {
            visible: !!claimNumber,
            content: translator(messages.referenceNumber, { num: claimNumber })
        },
       
        '@field': {
            phoneWide: {
                labelPosition: 'top'
            }
        },
        injuredWorkerId:{
            value:claimData?.lobs?.workersComp?.injuryIncident?.injured?.primaryContactName
        },
        injuryDateId:{
            
            value: getFormattedDate(claimData?.lossDate)
        },

        claimNumberId:{
            value:tbd===''?claimData?.claimNumber :tbd
            
        },
        adjusterName: {
            //value:claimData?.adjuster?.displayName
            value: getAdjusterName(claimData, translator)
        },
        injuryLocationId:{
            value:claimData?.lossLocation?.displayName
        },
        AdjusterNumber:{
            value:claimData?.adjuster?.phoneNumber
        },
        Claimstatic:{
            content:getClaimText()
        },
        whatPageDescriptionId:{
            value:claimData?.description
        }


    };

    const resolvers = {
        resolveCallbackMap: {
            handlePrint: handlePrint,
            handleClick:handleClick
           
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                id,
                path,
                
                overrides
            );
        },
        []
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        push: PropTypes.func.isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string.isRequired
        })
    }).isRequired
};

export default withRouter(ConfirmationPage);